export const DEFAULT_COUNTRY_CODE = 'HU';

export const DEFAULT_CURRENCY = 'HUF';
